export default __webpack_public_path__ + "static/media/logoItaiIcon.a76338da.svg";